import { configureStore } from "@reduxjs/toolkit";
import { authReducers } from "./auth/authSlice";
import { talksReducers } from "./talks/talksSlice";
import { categoryReducers } from "./category/categorySlice";
import { techniquesReducers } from "./techniques/techniquesSlice";
import { techniqueCategoryReducers } from "./techniqueCategory/techniqueCategorySlice";
import { programReducers } from "./programs/programsSlice";
import { nuggetReducers } from "./nuggets/nuggetSlice";
import { amritVarshaReducer } from "./amritVarsha/amritVarshaSlice";

const store = configureStore({
    reducer: {
        auth: authReducers,
        talks: talksReducers,
        category: categoryReducers,
        techniques: techniquesReducers,
        techniqueCategory: techniqueCategoryReducers,
        programs: programReducers,
        nuggets: nuggetReducers,
        amritVarsha: amritVarshaReducer
    }
});

export default store;